
const initState = {
    logged: false,
    course: '',
    token: '',
    num  : 0,
};



const AuthReducer = (state = initState, action) => {

    // dispatch({type:'login', token:'aaa', course:'bbb})
    if (action.type === 'login') {
        sessionStorage.setItem("TOKEN", action.token);
        sessionStorage.setItem("COURSE", action.course);
        sessionStorage.setItem("NUM", action.num);

        return {
            ...state,
            logged: true,
            course: action.course,
            token: action.token, 
            num  : action.num
        }
    }

    // dispatch({type:'logout'})
    else if (action.type === 'logout') {
        sessionStorage.removeItem("TOKEN");
        sessionStorage.removeItem("COURSE");
        sessionStorage.removeItem("NUM");

        return {
            ...state,
            logged: false,
            course: '',
            token: '',
            num  : 0,
        }
    }

    else {
        const token = sessionStorage.getItem("TOKEN");
        const course = sessionStorage.getItem("COURSE");
        const num = sessionStorage.getItem("NUM");

        if (token !== null && course !== null && num !== null) {
            state.token = token;
            state.course = course;
            state.logged = true;
            state.num    = num;
        }
        return state;
    }

};


export default AuthReducer;
